// LearnMoreContent.js
import React, { useState } from 'react';

const LearnMoreContent = ({ onClose }) => {
  const [openSection, setOpenSection] = useState(null);

  const toggleSection = (section) => {
    setOpenSection((prevSection) => (prevSection === section ? null : section));
  };

  const getChevronIcon = (isOpen) => {
    return isOpen ? 'zmdi-chevron-up' : 'zmdi-chevron-down';
  };

  return (
    <>
      {/* About Section */}
      <div onClick={() => toggleSection('about')} style={tooltipStyles.sectionHeader}>
        <i className={`zmdi ${getChevronIcon(openSection === 'about')}`} style={tooltipStyles.icon}></i>
        <h4>About DrugsPRO©️</h4></div>
        {openSection === 'about' && (
          <div style={{listStyle:"inside"}}>
        <p><b>DrugsPRO</b> offers harm reduction content for the prevention of overdoses and addictions. All information is provided as warnings only.</p>
    
    <ul>     <li>800+ substances featured</li>
        <li>4300+ reagent testing results</li>
        <li>Substance similarities map</li>
        <li>Names, classes, general info</li>
        <li>Effects (including „chemsex" related)</li>
        <li>Abuse and addiction potential</li>
        <li>Emergency and safer use guidance</li>
        <li>Interactions ("combos")</li>
        <li>Tolerance & cross-tolerance</li>
        <li>Psychedelic tolerance calculator</li>
        <li>Dosage and durations</li>
        <li>Effects prognosis chart</li>
    </ul><br></br>
       </div>
      )}

      {/* Disclaimer Section */}
      <div onClick={() => toggleSection('hr')} style={tooltipStyles.sectionHeader}>
        <i className={`zmdi ${getChevronIcon(openSection === 'hr')}`} style={tooltipStyles.icon}></i>
        <h4>Harm Reduction</h4>
      </div>
      {openSection === 'hr' && (
        <div>
                    <p>The best way to avoid substance risk is to avoid drug use, but that is not always possible. The information provided in this app is intended for harm reduction, particularly overdose and addiction prevention. We do not condone or condemn use of drugs, but consumption of psychoactive substances is always an avoidable health risk.</p>
          <p>Never assume any substance can be fully safe. Concentration, purity and adulteration vary greatly, even in case of samples acquired from the same source or bearing seemingly the same characteristics. Pure drugs are often lethal too.</p>

        </div>
      )}

            {/* Disclaimer Section */}
            <div onClick={() => toggleSection('drugchecking')} style={tooltipStyles.sectionHeader}>
        <i className={`zmdi ${getChevronIcon(openSection === 'drugchecking')}`} style={tooltipStyles.icon}></i>
        <h4>Drug Checking</h4>
      </div>
      {openSection === 'drugchecking' && (
        <div>
 <p><b>Reagent test kits</b> can indicate PRESENCE, but not QUANTITY. Mixtures can be detected with reagents only if an adulterant causes a darker color change than the expected substance (check in the app). PRO Test's multi-reagent kits are designed for detecting cuts. To reveal all ingredients and estimate their amounts, pair reagents with a TLC purity test kit. Use test strips to detect even trace amounts of fentanyl, nitazene, or xylazine. A positive or negative test result does not indicate if a substance is safe. No substance is 100% safe.</p>
 </div>
      )}
      {/* Disclaimer Section */}
      <div onClick={() => toggleSection('disclaimer')} style={tooltipStyles.sectionHeader}>
        <i className={`zmdi ${getChevronIcon(openSection === 'disclaimer')}`} style={tooltipStyles.icon}></i>
        <h4>Disclaimer</h4>
      </div>
      {openSection === 'disclaimer' && (
        <div>
          <p>The publisher of <b>DrugsPRO</b> strongly advises against the use of any psychoactive substance - either legal or illegal. Many of the substances listed are illegal under domestic or international law. Possessing, buying, or selling such compounds is punishable by law.</p>
        <p>All information is provided as warnings and cannot be used as a safety guarantee. Before making any decisions, further research is required.</p></div>
      )}
      {/* Acknowledgements Section */}
      <div onClick={() => toggleSection('data')} style={tooltipStyles.sectionHeader}>
        <i className={`zmdi ${getChevronIcon(openSection === 'data')}`} style={tooltipStyles.icon}></i>
        <h4>Data sources</h4>
      </div>
      {openSection === 'data' && (
        <div>
          <p><b>Sources:</b> Most drug combinations, doses, effects, and descriptions come from TripSit (combo.tripsit.me) and PsychonautWiki. Reagent results are compiled from public and private data. Substance map is based on the Universe of Drugs made by Espolea. Tryptamine / lysergamide dosage calculator based on code by CyberOxide. All presented information is intended for quick reference; users must conduct further research before making decisions.</p>
 </div>
      )}

      {/* Acknowledgements Section */}
      <div onClick={() => toggleSection('acknowledgements')} style={tooltipStyles.sectionHeader}>
        <i className={`zmdi ${getChevronIcon(openSection === 'acknowledgements')}`} style={tooltipStyles.icon}></i>
        <h4>Acknowledgements</h4>
      </div>
      {openSection === 'acknowledgements' && (
        <div>
          <p><b>DrugsPRO</b> would not have been possible without the following heroes of harm reduction: <b>Cyrilio</b> (initial database), <b>Rafael</b> from Kykeon Analytics (analytical methodology), <b>Marcin Biegun</b> (React development), <b>Wm. J. Holcomb</b> (share feature), <b>Bunk Police</b> (reagent research), <b>TripSit.me</b> (database), <b>PsychonautWiki.org</b> (database), and <b>/r/ReagentTesting</b> community (feedback).</p>
          <p>We dedicate this app to all passionate harm reduction enthusiasts. Special thanks to everyone who shares their drug-checking results publicly. As Alexander "Sasha" Shulgin wrote in TiHKaL: "Industry [is] benefiting economically in the War on Drugs, by charging inflated prices for reference and research samples."</p>
        </div>
      )}

      {/* Project Section */}
      <div onClick={() => toggleSection('project')} style={tooltipStyles.sectionHeader}>
        <i className={`zmdi ${getChevronIcon(openSection === 'project')}`} style={tooltipStyles.icon}></i>
        <h4>Made by PRO Test</h4>
      </div>
      {openSection === 'project' && (
        <p><br></br>
          <div><b>PRO Test</b></div>
          <div>Chemical Safet sp. z o.o.</div>
          <div>ul. Szaserów 38</div>
          <div>04-294 Warszawa</div>
          <div>POLAND</div>
          <br></br>
          <div>Message us!</div>
          <div><a href="mailto:testy@protestkit.eu">testy@protestkit.eu</a></div>
          <div><a href="https://protestkit.eu/" target="_blank" rel="noopener noreferrer">protestkit.eu</a></div>
          </p>
      )}

      <div style={tooltipStyles.buttonContainer}>
        <button onClick={onClose} style={tooltipStyles.buttonOk}>OK</button>
      </div>
    </>
  );
};


const tooltipStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
    
  },
  tooltip: {
    backgroundColor: 'white',
    padding: '20px',
    borderRadius: '8px',
    margin: '20px',
    width: '80%',
    maxWidth: "600px",
    textAlign: 'left',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
    overflowY: 'auto',
    maxHeight: '90vh',
  },
  sectionHeader: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    cursor: 'pointer',
    borderBottom: '1px solid #ddd',
    padding: '10px 0px',
    marginBottom: '5px',
  },
  icon: {
    fontSize: '18px',
    verticalAlign: 'middle',
    marginRight: '20px', // Add margin between icon and h4
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '20px',
  },
  buttonLearn: {
    margin: '0 10px',
    padding: '10px 20px',
    border: 'none',
    backgroundColor: '#a4a4a4',
    color: 'white',
    borderRadius: '5px',
    cursor: 'pointer',
  },
  buttonOk: {
    margin: '0 10px',
    padding: '10px 20px',
    border: 'none',
    backgroundColor: '#dcaa2e',
    color: 'white',
    borderRadius: '5px',
    cursor: 'pointer',
  },
};

export default LearnMoreContent;
